(($) => {

    const showChat = (elem, timing) => {
        window.setTimeout(function(){
            elem.removeClass('hide');
        }, timing);
    }

    const webchatBtn = $('.js-webchat');
    // If the webchat button exists on this page, show after an optional delay
    if (webchatBtn.length > 0) {
        const showTiming = webchatBtn.data('timing');
        showChat(webchatBtn, showTiming);
    }


    var mfcu_chat = () => {
        // Expected output when open: {success: true, open: true}
        // Expected output when closed: {success: true, open: false}
        fetch(`${site_data.WP_AJAX}?action=is_webchat_open`)
            .then(response => response.json())
            .then(result => {
                if( result.open ){
                    var window_url = site_data.WEBCHAT;
                    const ua = navigator.userAgent;
                    if (/iPad|iPhone|iPod/.test(ua)) {
                        window.location.href = window_url;
                    } else {
                        var window_height = 625;
                        var window_width = 700;
                        var window_name = "popup_window";
                        var window_properties = "width=" + window_width + ",height=" + window_height + ",scrollbars=yes,resizable=yes,status=no";
                        var new_window = window.open(window_url, window_name, window_properties);		
                        new_window.focus();
                    }
                } else{
                    window.location.href = site_data.WEBCHAT_LANDING;
                }
            });
    }

      var mfcu_callback = () => {
        // Expected output when open: {success: true, open: true}
        // Expected output when closed: {success: true, open: false}
        fetch(`${site_data.WP_AJAX}?action=is_callback_open`)
            .then(response => response.json())
            .then(result => {
                if( result.open ){
                    var window_url = "https://chat.missionfed.com/callback";
                    const ua = navigator.userAgent;
                    if (/iPad|iPhone|iPod/.test(ua)) {
                        window.location.href = window_url;
                    } else {
                        var window_height = 625;
                        var window_width = 700;
                        var window_name = "popup_window";
                        var window_properties = "width=" + window_width + ",height=" + window_height + ",scrollbars=yes,resizable=yes,status=no";
                        var new_window = window.open(window_url, window_name, window_properties);		
                        new_window.focus();
                    }
                } else {
                    window.location.href = "https://www.missionfed.com/about-us/request-a-call-back";
                }
            });
    }
    const callbackLink = $('.js-callback');
    callbackLink.on('click',function(){
        mfcu_callback();
    });
    
    webchatBtn.on('click',function(){
        mfcu_chat();
    });

})(jQuery)
